import { ArrowLeft } from 'lucide-react';
import { FactoringCompanyForm } from './FactoringCompanyForm';
import { useNavigate } from '../../hooks/useNavigate';

interface EditFactoringCompanyPageProps {
  companyId: string;
}

export function EditFactoringCompanyPage({ companyId }: EditFactoringCompanyPageProps) {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('factoring-companies');
  };

  const handleCancel = () => {
    navigate('factoring-companies');
  };

  return (
    <div className="min-h-screen bg-slate-100 p-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <button
            onClick={handleCancel}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors mb-4"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Factoring Companies
          </button>
          <h1 className="text-3xl font-bold text-slate-900">Edit Factoring Company</h1>
          <p className="text-slate-600 mt-1">Update company information</p>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <FactoringCompanyForm
            companyId={companyId}
            onClose={handleCancel}
            onSuccess={handleSuccess}
            isModal={false}
          />
        </div>
      </div>
    </div>
  );
}
